<template>
  <!--==================
    component shows all quote request (admin, operator)
    ===============-->

  <div class="col-12 pb-20 pt-20 px-0">
    <div class="form-group col-md-4 mb-4">
      <input @input="search($event)" class="form-control form-control-sm" type="search" placeholder="search" />
    </div>

    <div v-if="!quotes.length" class="alert alert-info col text-center" role="alert">
      <span class="font-italic">no quote found!</span>
    </div>

    <div v-if="quotes.length" class="card">
      <div class="table-responsive" style="max-height: 500px">
        <table class="table table-sm table-nowrap card-table">
          <thead class="text-primary">
            <tr>
              <th>#</th>
              <th>DATE</th>
              <th v-if="user.role === 'admin'">TYPE</th>
              <th v-if="user.role === 'admin'">OPERATOR</th>
              <th>QUOTE</th>
              <th v-if="user.role === 'admin'">PHONE</th>
              <th v-if="user.role === 'admin'">TRAVELER</th>
              <th>BOOKING STATUS</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(quote, index) in quotes" :key="quote.id">
              <td>{{ index + 1 }}</td>
              <td>{{ quote.createdAt | utcDateToLocalDate("ddd mmm dd yyyy HH:MM:ss") }}</td>
              <td v-if="user.role === 'admin'">{{ quote.type }}</td>
              <td v-if="user.role === 'admin' && quote.operator != undefined">{{ quote.operator.companyName }}</td>
              <td v-else-if="user.role === 'admin'" class="text-center">-</td>
              <td class="font-weight-bold">
                <a @click="viewQoute($event)" class="d-block p-3" href="#" :data-index="index">
                  {{ quote.fullName }} - {{ quote.email }}
                </a>
              </td>
              <td v-if="user.role === 'admin'">{{ quote.phone }}</td>
              <td v-if="user.role === 'admin'">{{ quote.adult + quote.child }}</td>
              <td>{{ quote.status }}</td>
              <td class="d-flex">
                <select
                  @change="status($event)"
                  class="form-control form-control-sm"
                  :data-status="quote.status"
                  :data-id="quote.id"
                  :data-index="index"
                  style="width: 150px"
                  :disabled="user.role != 'admin' && quote.status != 'still open'"
                >
                  <option :value="quote.status">Change status</option>
                  <option value="still open">Still Open</option>
                  <option value="booked">Booked</option>
                  <option value="not booked">Not Booked</option>
                </select>
                <button
                  v-if="user.role === 'admin'"
                  @click="remove($event)"
                  class="btn btn-sm btn-danger ml-4"
                  :data-id="quote.id"
                  :data-index="index"
                >
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="quote-detail"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header py-3">
            <h5 class="modal-title"><strong>Quote Request Details</strong></h5>
            <button @click="modalClose()" type="button" class="close" aria-label="Close">
              <span aria-hidden="true"><i class="icofont-close-circled text-danger"></i></span>
            </button>
          </div>
          <div v-if="detailIndex in quotes" class="modal-body">
            <div class="d-flex col-md-10 mb-4">
              <span class="col-md-3"><strong>Full Name :</strong></span>
              <span class="col-md-9">{{ quotes[detailIndex].fullName }}</span>
            </div>
            <div class="d-flex col-md-10 mb-4">
              <span class="col-md-3"><strong>Email :</strong></span>
              <span class="col-md-9">{{ quotes[detailIndex].email }}</span>
            </div>
            <div class="d-flex col-md-10 mb-4">
              <span class="col-md-3"><strong>Phone No. :</strong></span>
              <span class="col-md-9">{{ quotes[detailIndex].phone }}</span>
            </div>
            <div class="d-flex col-md-10 mb-4">
              <span class="col-md-3"><strong>Country :</strong></span>
              <span class="col-md-9">{{ quotes[detailIndex].country }}</span>
            </div>
            <div class="d-flex col-md-10 mb-4" v-if="quotes[detailIndex].type == 'package'">
              <span class="col-md-3"><strong>Tour :</strong></span>
              <a class="col-md-9" :href="packageUrl + quotes[detailIndex].package.id" target="_blank">{{
                quotes[detailIndex].package.title
              }}</a>
            </div>
            <div v-if="quotes[detailIndex].type != 'contact'" class="d-flex col-md-10 mb-4">
              <span class="col-md-3"><strong>Traveler :</strong></span>
              <span class="col-md-9">
                <span
                  >{{ quotes[detailIndex].adult > 0 ? quotes[detailIndex].adult + " adult " : ""
                  }}<span v-if="quotes[detailIndex].adult > 0" class="text-muted">(16+)</span></span
                >
                <span
                  >{{ quotes[detailIndex].child > 0 ? ", " + quotes[detailIndex].child + " child " : ""
                  }}<span v-if="quotes[detailIndex].child > 0" class="text-muted">(4 - 15)</span></span
                >
              </span>
            </div>
            <div v-if="quotes[detailIndex].type == 'custom'" class="d-flex col-md-10 mb-4">
              <span class="col-md-3"><strong>Arrival Date :</strong></span>
              <span class="col-md-9">{{ quotes[detailIndex].arrivalDate }}</span>
            </div>
            <div v-if="quotes[detailIndex].type == 'custom'" class="d-flex col-md-10 mb-4">
              <span class="col-md-3"><strong>Stay Duration :</strong></span>
              <span class="col-md-9">{{ quotes[detailIndex].duration }}</span>
            </div>
            <div v-if="quotes[detailIndex].type == 'custom'" class="d-flex col-md-10 mb-4">
              <span class="col-md-3"><strong>Trip :</strong></span>
              <span class="col-md-9">{{ quotes[detailIndex].trip }}</span>
            </div>
            <div v-if="quotes[detailIndex].type == 'custom'" class="d-flex col-md-10 mb-4">
              <span class="col-md-3"><strong>Budget :</strong></span>
              <span class="col-md-9">{{ quotes[detailIndex].budget }}</span>
            </div>
            <div v-if="quotes[detailIndex].type == 'package'" class="d-flex col-md-10 mb-4">
              <span class="col-md-3"><strong>Travel Date :</strong></span>
              <span class="col-md-9">{{ quotes[detailIndex].travelDate }}</span>
            </div>
            <div v-if="quotes[detailIndex].type == 'package'" class="d-flex col-md-10 mb-4">
              <span class="col-md-3"><strong>Other Activity :</strong></span>
              <span class="col-md-9">
                <span
                  v-if="
                    !quotes[detailIndex].safariActivity &&
                    !quotes[detailIndex].zanzibarActivity &&
                    !quotes[detailIndex].kilimanjaroActivity
                  "
                  class="text-muted"
                >
                  No activity
                </span>

                <span>
                  {{ quotes[detailIndex].zanzibarActivity > 0 ? quotes[detailIndex].zanzibarActivity + " day " : "" }}
                  <span v-if="quotes[detailIndex].zanzibarActivity > 0" class="text-muted">(Zanzibar)</span>
                </span>
                <span>
                  {{
                    quotes[detailIndex].kilimanjaroActivity > 0 ? quotes[detailIndex].kilimanjaroActivity + " day " : ""
                  }}
                  <span v-if="quotes[detailIndex].kilimanjaroActivity > 0" class="text-muted">
                    (Kilimanjaro)
                  </span></span
                >
                <span>
                  {{ quotes[detailIndex].safariActivity > 0 ? quotes[detailIndex].safariActivity + " day " : "" }}
                  <span v-if="quotes[detailIndex].safariActivity > 0" class="text-muted">(Safari)</span>
                </span>
              </span>
            </div>
            <div class="d-flex col-md-12 mb-4">
              <span class="col-md-2"><strong>Message :</strong></span>
              <p class="col-md-10">{{ quotes[detailIndex].description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Quote",

  data() {
    return {
      quotes: {},
      detailIndex: 0,
    };
  },

  computed: {
    ...mapGetters(["user", "operatorQuotes"]),

    filterQuotes() {
      return this.operatorQuotes;
    },

    packageUrl() {
      return process.env.VUE_APP_PACKAGE_URL;
    },
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      await this.getQuotes();
    });
  },

  methods: {
    ...mapActions(["fetchOperatorQuotes", "updateQuoteStatus", "deleteOperatorQuote"]),

    status(e) {
      let id = e.target.getAttribute("data-id");
      let fromStatus = e.target.getAttribute("data-status");
      let toStatus = e.target.value;

      if (this.user.role != "admin" && fromStatus === "still open") {
        this.updateQuoteStatus({ id, status: toStatus });
      } else if (this.user.role === "admin") {
        this.updateQuoteStatus({ id, status: toStatus });
      }
    },

    viewQoute(e) {
      e.preventDefault();

      let index = e.target.getAttribute("data-index");
      this.detailIndex = index;

      $("#quote-detail").modal("show");
    },

    remove(e) {
      let id = e.target.getAttribute("data-id");
      let dP = this;

      $.confirm({
        title: "",
        content: "Are you sure want to delete this quote?",
        buttons: {
          confirm: () => {
            dP.deleteOperatorQuote(id);
          },
          cancel: () => {},
        },
      });
    },

    search(e) {
      let value = e.target.value;

      this.quotes = this.filterQuotes.filter((v) => {
        return (
          v.createdAt.includes(value) ||
          (v.operator != undefined && v.operator.companyName.includes(value)) ||
          v.email.includes(value) ||
          v.fullName.includes(value) ||
          v.phone.includes(value) ||
          v.status.includes(value)
        );
      });
    },

    async getQuotes() {
      if (this.user.role === "operator") {
        await this.fetchOperatorQuotes(this.user.id);
        this.quotes = this.operatorQuotes;
      } else {
        await this.fetchOperatorQuotes();
        this.quotes = this.operatorQuotes;
      }
    },

    modalClose() {
      $("#quote-detail").modal("hide");
    },
  },
};
</script>
